import React from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Approach } from "./components/Approach";
import { Coaches } from "./components/Coaches";
import { Players } from "./components/Players";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans" data-id="element-0" data-mp="2risy0r0e74jk">
      <Header data-id="element-1" data-mp="2mn5ccll4ctit" />
      <main data-id="element-2" data-mp="2mndr6j0sy8wn">
        <Hero data-id="element-3" data-mp="2mjpvpebsrcfa" />
        <About data-id="element-4" data-mp="2mjzp7bw1w1pq" />
        <Services data-id="element-5" data-mp="31agpgrwy8ll1" />
        <Coaches data-id="element-6" data-mp="31ayv2f5i4c5m" />
        <Approach data-id="element-7" data-mp="31bi7xhgaoacs" />
        <Players data-id="element-8" data-mp="31c1l6kv02akh" />
        <Contact data-id="element-9" data-mp="31cjk5p91r2w3" />
      </main>
      <Footer data-id="element-10" data-mp="2wjqhr811w6n6" />
    </div>;
}